<mat-card class="canvas-card" [class.is-root]="isRoot" [class.level-selected]="isThisLevelSelected()">
  <mat-card-header class="level-header-clickable" (click)="onSelectLevel()">
    <mat-icon mat-card-avatar [class.root-icon]="isRoot">
      {{ isRoot ? 'description' : 'folder_open' }}
    </mat-icon>
    <mat-card-title>{{ level.name || ('FORM_BUILDER.LEVEL_NAME' | translate) }}</mat-card-title>
    <mat-card-subtitle *ngIf="isRoot">
      {{ 'FORM_BUILDER.ROOT_LEVEL_HINT' | translate }}
    </mat-card-subtitle>
    <button mat-icon-button class="level-edit-btn" matTooltip="{{ 'ACTION.EDIT' | translate }}">
      <mat-icon>settings</mat-icon>
    </button>
  </mat-card-header>

  <mat-card-content class="canvas-content">
    <!-- Native HTML5 Drop Zone for palette items -->
    <div
      class="drop-zone"
      cdkDropList
      [id]="'level-' + level.id"
      [cdkDropListData]="level.fields"
      [cdkDropListConnectedTo]="connectedDropLists"
      (cdkDropListDropped)="onDrop($event)"
      [class.empty]="level.fields.length === 0"
      [class.drag-over]="isDragOver"
      (dragover)="onNativeDragOver($event)"
      (dragleave)="onNativeDragLeave($event)"
      (drop)="onNativeDrop($event)">
      
      <!-- Empty State -->
      <div *ngIf="level.fields.length === 0" class="empty-state">
        <mat-icon class="empty-icon">add_circle_outline</mat-icon>
        <p>{{ 'FORM_BUILDER.DROP_FIELDS_HERE' | translate }}</p>
        <p class="empty-hint">{{ 'FORM_BUILDER.DRAG_FROM_LEFT' | translate }}</p>
      </div>

      <!-- Field Items - simple list, no CDK reordering for now -->
      <div
        *ngFor="let field of level.fields; let i = index; trackBy: trackByFieldId"
        class="field-item"
        cdkDrag
        [cdkDragData]="field"
        [class.selected]="isFieldSelected(field)"
        (click)="selectField(field)">
        
        <div class="drag-handle" cdkDragHandle>
          <mat-icon>drag_indicator</mat-icon>
        </div>

        <!-- Field Preview -->
        <div class="field-preview">
          <mat-icon class="field-type-icon">{{ getFieldTypeIcon(field.type) }}</mat-icon>
          <div class="field-info">
            <span class="field-label">{{ field.label || ('FORM_BUILDER.UNNAMED_FIELD' | translate) }}</span>
            <span class="field-type">{{ 'FORM_BUILDER.FIELD_TYPES.' + field.type.toUpperCase() | translate }}</span>
          </div>
          <mat-chip *ngIf="field.required" class="required-chip">
            {{ 'FORM_BUILDER.REQUIRED' | translate }}
          </mat-chip>
          <mat-icon *ngIf="field.allowPhoto" class="photo-indicator" matTooltip="{{ 'FORM_BUILDER.CONFIG.ALLOW_PHOTO' | translate }}">photo_camera</mat-icon>
        </div>

        <!-- Actions -->
        <div class="field-actions">
          <button mat-icon-button (click)="selectField(field); $event.stopPropagation()" matTooltip="{{ 'ACTION.EDIT' | translate }}">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button (click)="removeField(field, $event)" matTooltip="{{ 'ACTION.DELETE' | translate }}">
            <mat-icon class="delete-icon">delete</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- Add Nested Level Button -->
    <button
      mat-raised-button
      color="accent"
      class="add-level-btn"
      (click)="onAddNestedLevel()">
      <mat-icon class="mr-1">add</mat-icon>
      {{ 'FORM_BUILDER.ADD_NESTED_LEVEL' | translate }}
    </button>
  </mat-card-content>
</mat-card>
